// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__32eot","col":"Table_col__2_FIN","fulfillmentStatus":"Table_fulfillmentStatus__2UqQp","emailCol":"Table_emailCol__4XQou"};